<style lang="less" scoped>
  @import "../../../vars.less";

  .material-list {
    font-size: 12px;
    line-height: 1.8;
  }
  .material-item:not(:last-child) {
    padding-bottom: @space-medium;
    margin-bottom: @space-medium;
  }
  .material-item:last-child:after {
    display: none;
  }
  .material-line {
    display: flex;
    justify-content: center;
    margin: 0;
  }
  .material-line-left {
    flex: auto;
  }
  .material-line-right {
    flex: none;
  }
  .secondary {
    color: @text-color-secondary;
  }
  .comment-line {
    margin: 0;
  }
  .collapse-handler {
    // padding:
    text-align: center;
    font-size: 14px;
    padding-top: @space-medium;
  }
  .editable {
    color: @primary-color;
    margin-left: @space-small;
  }
  .shit {
    padding: 0;
    font-size: 12px;
  }
</style>

<template>
  <div>
    <ul class="material-list">
      <li
        v-for="(item, index) of (collapsable && collapsed ? items.slice(0, 1) : items)"
        :key="index"
        class="material-item"
        :class="index == items.length - 1 ? '' : 'van-hairline--bottom'">
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('物料号') }}: {{item.material_number}}</span>
          <material-status class="material-line-right" :value="item.item_status"/>
        </p>
        <p class="material-line secondary">
          <span class="material-line-left">{{ $t('西门子订货号') }}: {{item.material_mlfb}}</span>
          <span class="material-line-right">{{ $t('需求数量') }}: {{item.item_quantity}}</span>
        </p>
        <p class="material-line">
          <span class="material-line-left">{{ $t('预计备妥时间') }}: {{item.exp_arrival_date}}</span>
          <span class="material-line-right" v-if="!editable">
            {{ $t('要求备妥时间') }}{{ item.ReqestSiemensDeliveryDate2 ? 2 : 1 }}:
            {{ item.ReqestSiemensDeliveryDate2 || item.ReqestSiemensDeliveryDate1 }}
          </span>
        </p>
        <p class="material-line" style="justify-content: flex-start;" v-if="editable">
          <van-checkbox size="small" icon-size="14" :bind-group="false"
            :value="item.IsExpedite" shape="square" :disabled="item.isRejection || !item.IsApply"
            @input="v => handleRequestChange(index, v)">
            {{ $t('要求备妥时间') }}{{ item.ReqestSiemensDeliveryDate2 ? 2 : 1 }}:
          </van-checkbox>
          <span class="editable" @click="() => startChangeDate(index)">
            {{ item.ReqestSiemensDeliveryDate2 || item.ReqestSiemensDeliveryDate1 }}
            <van-icon v-if="editable" name="arrow-down" />
          </span>
        </p>
        <p class="comment-line secondary" v-if="!editable">
          {{ $t('备注') }}{{ item.Remark2 ? 2 : 1 }}:
          <span>{{item.Remark2 || item.Remark1}}</span>
        </p>
        <van-field v-else type="textarea" :rows="1" class="shit" autosize :disabled="item.isRejection || !item.IsApply"
          :value="item.isRejection || !item.IsApply ? item.toolTip : item.Remark1" label-width="auto" @input="(v) => handleRemarkChange(index, v)"
          :label="$t('备注')"  maxlength="140"
          :placeholder="$t('请填写描述信息（小于140字）')"
          show-word-limit
        />
      </li>
    </ul>
    <div v-if="collapsable && items && items.length > 1" class="collapse-handler" @click="more">
      {{ collapsed ? $t('更多') : $t('收起') }}
      <van-icon :name="collapsed ? 'arrow-down' : 'arrow-up' " />
    </div>
    <van-popup v-model="dateShow" position="bottom" :get-container="getContainer">
      <van-datetime-picker :title="$t('要求备妥时间')"
        type="date" :min-date="new Date()"
        @confirm="onDateConfirm"
        @cancel="dateShow = false" />
    </van-popup>
  </div>
</template>

<script>
import { Icon, DatetimePicker, Popup, Field, Checkbox } from 'vant'
import MaterialStatus from '../../../components/MaterialStatus'
import format from '../../../utils/format'

export default {
  name: 'material-list',
  components: {
    MaterialStatus,
    'van-icon': Icon,
    'van-datetime-picker': DatetimePicker,
    'van-popup': Popup,
    'van-field': Field,
    'van-checkbox': Checkbox
  },
  props: {
    items: {
      type: Array,
      default () { return [] }
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      collapsed: true,
      dateShow: false,
      currIndex: null
    }
  },
  methods: {
    more () {
      this.collapsed = !this.collapsed
    },
    startChangeDate (index) {
      if (this.editable) {
        this.currIndex = index
        this.dateShow = true
      }
    },
    onDateConfirm (date) {
      this.items[this.currIndex].ReqestSiemensDeliveryDate1 = format(date)
      this.dateShow = false
      this.$emit('change', [...this.items])
    },
    getContainer () {
      return window.document.body
    },
    handleRemarkChange (index, v) {
      this.items[index].Remark1 = v
      this.$emit('change', [...this.items])
    },
    handleRequestChange (index, v) {
      this.items[index].IsExpedite = v
      this.$emit('change', [...this.items])
    }
  }
}
</script>
